import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { RouteMetadataService } from '../services/route-metadata.service';
import { ToastService } from '../services/toast.service';
import { eTypeUser } from '../constants/options-system';
import { TOAST_MESSAGES } from '../constants/app.constants';
import { getCompanyHomeUrl, getCurrentUserTypeId } from './not-found.guard';
import { STATIC_COMPANY_PAGES } from '../constants/static-pages';

/**
 * Bloquea la navegación directa (por URL) a páginas de /dashboard/company/* que el
 * tipo de usuario actual no tiene habilitadas en system_option/user_type_system_option
 * (el mismo árbol que arma el menú lateral). Antes de este guard, el árbol de permisos
 * solo controlaba qué se veía en el menú, no qué rutas eran realmente accesibles.
 */
export const permissionGuard: CanActivateChildFn = async (childRoute, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const routeMetadataService = inject(RouteMetadataService);
  const toastService = inject(ToastService);

  // Rutas sin página implementada: las resuelve notFoundGuard con su propio mensaje,
  // para no reportar como "sin permisos" algo que en realidad no existe.
  if (childRoute.routeConfig?.path === '**') return true;

  const userTypeId = getCurrentUserTypeId(authService);

  // El árbol de system_option solo modela permisos para Business Admin / Admin iPay.
  if (userTypeId !== eTypeUser.AdminBusiness && userTypeId !== eTypeUser.AdminIpay) {
    return true;
  }

  const path = state.url.split('?')[0].replace(/^\/dashboard\/company\/?/, '');
  if (!path) return true; // /dashboard/company sin hijo (home de Admin iPay)
  if (STATIC_COMPANY_PAGES[path]) return true; // p.ej. Mi perfil: no depende del árbol de opciones

  const allowed = await routeMetadataService.isRouteAllowed(path);
  if (allowed) return true;

  toastService.HanddleWarningMessage(TOAST_MESSAGES.UNAUTHORIZED_ACCESS, 'Acceso denegado');

  return router.parseUrl(getCompanyHomeUrl(userTypeId));
};
